import React from 'react'
import MobileNumber from './MobileNumber.jsx';
import actions from '../actions/LoginAction';
import LoginStore from '../stores/LoginStore';

export default class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
      isPasswordInfo: '',
      loginInfo: [],
      isSignIn: false,
    };
    this.getLoginDetails = this.getLoginDetails.bind(this);
  }

  getLoginDetails() {
    var loginInfo = LoginStore.getLoginDetails()
    this.setState({ loginInfo: LoginStore.getLoginDetails(), isShow: true });

    if (typeof loginInfo === 'object') {
      this.props.history.push('/FactoryInformationPage')
    }
    else {
      if (loginInfo.indexOf('undefined') > 0) {

        alert("मोबाईल नं. आणि  पासवर्ड चुकीचा आहे")
      }
    }
  }

  componentWillMount() {
    LoginStore.addListener('getloginDetails', this.getLoginDetails)
  }

  componentWillUnmount() {
    LoginStore.removeListener('getloginDetails', this.getLoginDetails)
  }

  saveLoginInfo(e) {
    e.preventDefault();
    actions.saveLogin(this.state);
  }

  saveSignInInfo(e, branch) {
    this.setState({
      isSignIn: true,
      branch: branch,
    });
  }

  PasswordInfo(e) {
    this.setState({
      isPasswordInfo: true,
    });
    this.props.history.push('/MobileNumber')
  }

  handleInputChange(e) {
    e.preventDefault();
    var name = e.target.name;
    var state = this.state;
    state[name] = e.target.value;
    this.setState(state);
  }

  render() {
    return (
      <div>
        <div className="navbarpages navbarpagesbg">
          <div className="navbar_left">
            <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
          </div>
          <div className="content-block" ><br /><br /><br /><br />
            <h3 style={{ 'padding-left': '60px' }}><b style={{ 'color': '#0000FF' }}>वाहतुकदार LOGIN</b></h3>
            <div className="loginform">
              <form id="LoginForm" method="post">
                <input type="Number" id="userName" name="userName" className="form_input required" value={this.state.userName} onChange={(e) => this.handleInputChange(e)} placeholder="मोबाइल नं टाका" />
                <input type="password" id="password" name="password" className="form_input required" value={this.state.password} onChange={(e) => this.handleInputChange(e)} placeholder="पासवर्ड  टाका" />
                <div>
                  <input type="submit" name="submit" className="form_submit" onClick={(e) => { this.saveLoginInfo(e) }} value="LOG IN" />
                </div> <br />
                <div className="forgot_pass"><a href="#" data-popup=".popup-forgot" className="open-popup" onClick={(e) => { this.PasswordInfo(e) }}>Forgot Password?</a></div>
              </form>
            </div>

            <div>
              {this.state.isPasswordInfo ?
                <MobileNumber /> :
                null
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}






// WEBPACK FOOTER //
// ./src/component/Login.jsx